import { render, staticRenderFns } from "./EditLot.vue?vue&type=template&id=45236521&"
import script from "./EditLot.vue?vue&type=script&lang=js&"
export * from "./EditLot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports